import { container } from 'tsyringe'
import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule,
} from 'vuex-module-decorators'
import {
  NotificationApiRequest,
  DeleteNotificationRequest,
  UpdateNotificationRequest,
} from '@/data/payload/api/NotificationRequest'
import store from '@/app/store/store'
import { NotificationPresenter } from '@/app/ui/presenters/NotificationPresenter'
import { Notification } from '@/domain/entities/Notification'
import router from '@/router'
import Vue from 'vue'
import { AuthModule } from './auth'

export interface NotificationState {
  notificationData: Notification
  isLoading: boolean
  fields: any
  paginationParam: Object
}

@Module({ namespaced: true, dynamic: true, store, name: 'notifications' })
class Notifications extends VuexModule implements NotificationState {
  public isLoading = true
  public Pages = 0
  public Limit = 10
  public fields = [
    { key: 'selected', sortable: false },
    { key: 'no', sortable: false },
    { key: 'title', sortable: true },
    { key: 'attachment', sortable: false },
    { key: 'deletable', sortable: false },
    { key: 'updatedAt', sortable: false },
    { key: 'createdAt', sortable: false },
    { key: 'actions', sortable: false },
  ]
  public notificationData = new Notification(true, '')
  public paginationParam = {
    paging: {
      page: 1,
      limit: 10,
    },
    sort: {
      column: 'CreateDate',
      type: 'desc',
    },
    search: '',
  }

  @Action
  public async getNotificationData() {
    this.setLoading(true)
    const presenter = await container.resolve(NotificationPresenter)
    presenter
      .loadNotification(this.paginationParam)
      .then((res: Notification) => {
        this.setNotificationData(res)
        //  console.log('resssss1111', res)
      })
      .catch((error) => {
        if (error.response.status === 401) {
          AuthModule.logOut()
          router.push(`/login`).then(() => {
            Vue.prototype.$notify({
              title: 'Session Expired',
              message: 'Session was expired please login again',
              type: 'error',
              duration: 3000,
            })
          })
        }
        router.push('/404/index')
        console.error('error', error)
      })
      .finally(() => {
        this.setLoading(false)
        this.setpages(this.paginationParam.paging.page)
        this.setlimit(this.paginationParam.paging.limit)
      })
  }

  @Action
  public async postNotification(params: {
    ownerType: string
    ownerId: string
    title: string
    content: string
    attachment: any
    deletable: string
    material: string
    idMaterial: string
    fileMaterial: string
    notificationType : string
    externalLink : string
  }) {
    this.setLoading(true)
    const presenter = await container.resolve(NotificationPresenter)
    presenter
      .postNotification(
        new NotificationApiRequest(
          params.ownerType,
          params.ownerId,
          params.title,
          params.content,
          params.attachment,
          params.deletable,
          params.material,
          params.idMaterial,
          params.fileMaterial,
          params.notificationType,
          params.externalLink
        )
      )
      .then((res) => {
        Vue.prototype.$notify({
          title: 'Notification',
          message: res.message,
          type: 'success',
          duration: 5000,
        })
        this.getNotificationData()
      })
      .catch((error) => {
        this.setLoading(false)
        Vue.prototype.$notify({
          title: 'Notification',
          message: 'Failed',
          type: 'error',
          duration: 5000,
        })
      })
  }

  @Action
  public async updateNotification(params: {
    id: number
    title: string
    content: string
    deletable: string
  }) {
    this.setLoading(true)
    const presenter = await container.resolve(NotificationPresenter)
    presenter
      .updateNotification(
        new UpdateNotificationRequest(
          params.title,
          params.content,
          params.deletable
        ),
        params.id
      )
      .then((res) => {
        Vue.prototype.$notify({
          title: 'Notification',
          message: res.message,
          type: 'success',
          duration: 5000,
        })
        this.getNotificationData()
      })
      .catch((error) => {
        this.setLoading(false)
        Vue.prototype.$notify({
          title: 'Notification',
          message: 'Failed',
          type: 'error',
          duration: 5000,
        })
      })
  }

  @Action
  public async deleteNotification(params: { ids: any }) {
    this.setLoading(true)
    const presenter = await container.resolve(NotificationPresenter)
    presenter
      .deleteNotification(new DeleteNotificationRequest(params.ids))
      .then((res) => {
        Vue.prototype.$notify({
          title: 'Notification',
          message: res.message,
          type: 'success',
          duration: 5000,
        })
        this.getNotificationData()
      })
      .catch((error) => {
        this.setLoading(false)
        Vue.prototype.$notify({
          title: 'Notification',
          message: 'Failed',
          type: 'error',
          duration: 5000,
        })
      })
  }

  @Mutation
  private setNotificationData(notification: Notification) {
    this.notificationData = notification
  }

  @Mutation
  private setLoading(isLoading: boolean) {
    this.isLoading = isLoading
  }

  @Mutation
  private setpages(pages: number) {
    this.Pages = pages
  }
  @Mutation
  private setlimit(limit: number) {
    this.Limit = limit
  }
}

export const NotificationModule = getModule(Notifications)
